import { Group, Skeleton, useMantineTheme, Stack } from '@mantine/core';

function ConfirmModalSkeleton() {
  const theme = useMantineTheme();

  return (
    <Stack spacing={theme.other.spacing._8}>
      <Skeleton h={24} w={130} />
      <Skeleton h={20} w={300} />

      <Group
        mt={theme.other.spacing._16}
        w="100%"
        spacing={theme.other.spacing._8}
        noWrap
        position="right"
      >
        <Skeleton w={100} h={40} />
        <Skeleton w={100} h={40} />
      </Group>
    </Stack>
  );
}

export default ConfirmModalSkeleton;
